<template>

  <div id="page-user-list">

    <vx-card class="mb-base">
        <div class="flex justify-between">
            <div class="flex md:w-4/12">
                <v-select class="md:w-4/12" :options="years" :clearable="false" v-model="year"></v-select>
            </div>
            <vs-button @click="exportData">Download to Excel</vs-button>
        </div>
        <div class="my-4 flex align-center justify-center">
            <h4>Yearly Report</h4>
        </div>
        <vue-apex-charts type="bar" height="350" :options="graphicReport.options" :series="graphicReport.series"></vue-apex-charts>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import chartData from '../chartData.js'
import recipe from "@/recipe"

export default {
    components: {
        VueApexCharts
    },
    data() {
        return {
            loaded: false,
            graphicReport: {
                series: [],
                options: {}
            },
            year: {
                label: '',
                value: ''
            },
            years: [],
        }
    },
    methods : {
        exportData () {
            let start_date  = `01-01-${this.year.value}`
            let end_date    = `31-12-${this.year.value}`
            window.open(`${recipe}/api/v1/technical/ticketing/trouble-ticket/export/${start_date}/${end_date}/excel`, '_blank');
        },
        getCurrentTime () {
            var now       = new Date()
            var thisYear  = now.getFullYear()
            var min       = 2014;
            var max       = thisYear;

            for (var i = min; i <= max; i++) {
                this.years.push({
                label : i,
                value : i
                })
            }

            this.year = {
                label : thisYear,
                value : thisYear
            }

            
        },
        getGraphicReport () {
            const self = this
            this.$store.dispatch('report/fetchReportYearly', { 
                year: self.year.value
            })
            .then(res => {
                const data = res.data.data
                
                self.graphicReport.series  = data.series
                self.graphicReport.options = {
                    chart: {
                        height: 400,
                        type: 'bar',
                        events: {
                            click: function(chart, w, e) {
                                // console.log(chart, w, e)
                            }
                        }
                    },
                    // colors: ['#3498db', '#2ecc71', '#f1c40f', '#e74c3c', '#9b59b6', '#34495e', '#1abc9c', '#e67e22'],
                    plotOptions: {
                        bar: {
                        columnWidth: '45%',
                        distributed: true,
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    legend: {
                        show: false
                    },
                    xaxis: {
                        categories: data.categories,
                        labels: {
                            rotate: 0,
                            rotateAlways: false,
                            hideOverlappingLabels: true,
                            showDuplicates: false,
                            trim: false,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                // colors: ['#3498db', '#2ecc71', '#f1c40f', '#e74c3c', '#9b59b6', '#34495e', '#1abc9c', '#e67e22'],
                                fontSize: '9px',
                                cssClass: 'apexcharts-xaxis-title'
                            }
                        }   
                    }
                } 
            })
            .catch(err => {
                if (!err.response) {
                    // network error
                    err.response = {
                        data: {
                        message: 'Server error'
                        }
                    };
                }
                this.$vs.notify({
                title:'Opps something error',
                text: err.response.data.message,
                color:'danger'})
            })
            .finally(() => {
                this.onLoaded()
            })
        },
        onLoaded(){
            this.loaded = true;
            this.$vs.loading.close()
        },
        loading () {
            this.loaded = false;

            this.$vs.loading({
                type: 'border',
                color: 'primary',
                text: `Wait a minute, It's getting data.`
            })
        },
    },
    watch : {
        year () {
            this.getGraphicReport()
        }
    },
    created() {
        this.getCurrentTime()
        this.getGraphicReport()
    }
}
</script>
